import { useEffect } from 'react';

import page from '@gojob/tracking/page';
import { useLocation } from '@reach/router';

/**
 * Homepage of the board can trigger navigate and have pathname changed
 * pathname are also monitored on offre-emploi-interim
 * to avoid double tracking we trigger only one time page tracking on Homepage
 */
const useTrackHomepageView = () => {
  const { pathname } = useLocation();
  const pageName = pathname.replace(/\/$/, '');
  useEffect(() => {
    page({ pageName, pageCategory: 'gojob.com' });
  }, []);
};

export default useTrackHomepageView;
